// ** Reactstrap Imports
import React, { useEffect } from 'react'

// ** Custom Hooks
import { useSkin } from '@hooks/useSkin'

// ** Styles
import '@styles/base/pages/page-misc.scss'
import useJwt from '../../../auth/jwt/useJwt'
import { trans } from '../../../configs/i18n'

const Maintenance = () => {
    // ** Hooks
    const { skin } = useSkin()

    useEffect(() => {
        useJwt.getIsMaintenance().then(response => {
            if (!response.data.isMaintenance) {
                window.location.href = '/feed'
            }
        })
    }, [])

    const illustration = skin === 'dark' ? 'under-maintenance-dark.svg' : 'under-maintenance.svg',
        source = require(`@src/assets/images/pages/${illustration}`)
    const illustrationLogo = skin === 'dark' ? 'Betfolio_logo_2.png' : 'Betfolio_logo_1.png',
        logo = require(`@src/assets/images/logo/${illustrationLogo}`)
    return (
        <div className="misc-wrapper">
            <div className={'mb-2'}>
                <a className="brand-logo" href="/">
                    <img src={logo} width={175} alt="logo" className="brand-text text-primary ms-1 pb-2"></img>
                </a>
            </div>
            <br />
            <div className="misc-inner p-2 p-sm-3 pt-3">
                <div className="w-100 text-center pt-4">
                    <h2 className="mb-1">{trans('maintenance.header')} 🛠</h2>
                    <p className="mb-3">{trans('maintenance.text')}</p>
                    <img className="img-fluid" src={source} alt="Under maintenance page" />
                </div>
            </div>
        </div>
    )
}
export default Maintenance
